import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Drawer } from 'antd'
import { DEFAULT_DRAWER_WIDTH } from 'utils/drawerConstants'
import Icon from 'components/patterns/Icon'
import { classNames } from 'utils/utils'

import 'styles/ChecDrawer.css'

// TODO: delete this file
export default class ChecDrawer extends Component {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    children: PropTypes.node,
    closable: PropTypes.bool,
    visible: PropTypes.bool.isRequired,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onClickToggle: PropTypes.func,
    mask: PropTypes.bool,
    destroyOnClose: PropTypes.bool,
    fullscreen: PropTypes.bool,
    bodyStyle: PropTypes.object,
    placement: PropTypes.string,
    className: PropTypes.string,
  }

  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    children: '',
    closable: false,
    width: DEFAULT_DRAWER_WIDTH,
    mask: false,
    destroyOnClose: false,
    fullscreen: false,
    bodyStyle: null,
    placement: 'right',
  }

  componentDidUpdate(prevProps) {
    const { visible, fullscreen } = this.props

    // class to override antd inline styles breaking drawer
    // when scroll bar is visible
    if (!fullscreen && prevProps.visible !== visible) {
      if (visible) {
        document.body.classList.add('chec-drawer-open')
      } else {
        document.body.classList.remove('chec-drawer-open')
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('chec-drawer-open')
  }

  handleClickToggle = () => {
    const { visible, onClickToggle, mask } = this.props

    if (mask) return null

    return onClickToggle(!visible)
  }

  renderToggle = () => {
    const { fullscreen, visible } = this.props

    if (fullscreen) return null

    const icon = visible ? 'FaCaretRight' : 'FaCaretLeft'

    return (
      <div
        className="chec-drawer-arrow-toggle"
        onClick={this.handleClickToggle}
      >
        <Icon width={16} height={16} icon={icon} />
      </div>
    )
  }

  computeWidth = (() => {
    const { fullscreen, width } = this.props

    if (fullscreen) return '100%'
    return width
  })()

  render() {
    const { children, fullscreen, bodyStyle, placement } = this.props
    return (
      <Drawer
        {...this.props}
        width={this.computeWidth}
        bodyStyle={bodyStyle}
        placement={placement}
        className={classNames('chec-drawer', { fullscreen })}
      >
        {this.renderToggle()}
        {children}
      </Drawer>
    )
  }
}
